export default __webpack_public_path__ + "static/media/M.3.2.4f901412.svg";